<template>
  <div>
    <div style='padding:10px;'>
      <div style="float:right;">
        <div style="text-align:center;">
          <a href="https://www.ideal-solutions.fr/sos"><img src="https://aloha.crm-ideal.fr/img/AnyDesk-Blue.png" alt="support" style="width:10%;"/></a>
          <p>Assistance</p>
        </div>
        <span>Cliquez sur le logo à l'invitation du technicien Ideal</span>
      </div>
      <br/>
      <span>Notre support est disponible du lundi au vendredi de 9h à 12h et de 14h à 17h</span>
      <br/>
      <span>Vous pouvez le joindre au <a href="tel:09 71 18 06 18">09 71 18 06 18</a> ou par mail à l'adresse <a href="mailto:assistance@ideal360.fr">assistance@ideal360.fr</a></span>
      <br/>
      <span>Vous pouvez également créer un ticket en cliquant sur le bouton ci-dessous</span>
      <br/>
      <div style="width:80%;">
        <div id='recherche'>
          <b-row>
            <b-col class="my-1">
              <b-button v-on:click.prevent="openModal($event.target)" class="createTicket" style="float:right;">Créer un ticket</b-button>
            </b-col>
          </b-row>         
        </div>
          <el-table :data="pagedTableData" style="width: 100%" @filter-change="filterChange">
            <el-table-column prop="ref" label="Référence" width="150">
            </el-table-column>
            <el-table-column prop="type_label" label="Type de l'incident" width="200" :filters="optionsType">
            </el-table-column>
            <el-table-column prop="subject" label="Sujet">
            </el-table-column>
            <el-table-column prop="datec" label="Date" width="120">
            </el-table-column>
            <el-table-column prop="severity_label" label="Sévérité" width="150" :filters="optionsSeverite">
            </el-table-column>
            <el-table-column prop="statut_label" label="Statut" width="120" :filters="optionsStatut">
            </el-table-column>
            <el-table-column label="Opérations" width="120">
              <template slot-scope="scope">
                <span><i @click="expandTicketInfo(scope.row)" class="far fa-comments"></i></span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="totalRows>perPage">
            <el-pagination
              :page-size=perPage
              :pager-count="11"
              layout="prev, pager, next"
              :total=filteredData.length
              @current-change="setPage">
            </el-pagination>
          </div>
      </div>
    </div>

    <b-modal id="modalInfoTicket" @hide="closeInfoTicket" ref="modalInfoTicket" :title="modalInfoTicket.title" hide-footer>
      <div>
        <h4>Message initial :</h4>
        <p style="border: 0.1px solid gray;padding: 0.5rem;background: rgb(220, 220, 220);height: 110px;max-height: 110px;overflow-y: scroll;" v-html="messageInitial"></p>
      </div>
      <div class="messagesEtBannette">
        <div class="messages" id="messages">
          <template v-if="ticketMessages.length">
            <div style="padding: 10px;" v-for="messages in ticketMessages" :key="messages">
              <div v-if="info.socId == messages.fk_user_action_socid && messages.fk_user_action_socid" class="myMessage">
                <el-card class="message">
                  <div class="text item">
                    <span v-html="messages.message"></span>
                  </div>
                  <div style="padding-top: 10px;">
                    <span>{{ messages.fk_user_action_string }} le {{ viewDate(messages.datec) }}</span>
                  </div>
                </el-card>
              </div>
              <div v-else class="otherMessage">
                <el-card class="message">
                  <div class="text item">
                    <span v-html="messages.message"></span>
                  </div>
                  <div style="padding-top: 10px;">
                    <span>{{ messages.fk_user_action_string }} le {{ viewDate(messages.datec) }}</span>
                  </div>
                </el-card>
              </div>
            </div>
          </template>
        </div>
        <div class="bannette" id="bannette">
          <div class="titreBannette">
            <h5>Fichiers joints ({{ filesTicket.length }})</h5>
          </div>
          <div class="fichiers">
            <template v-if="filesTicket.length">
              <div style="padding: 10px;" v-for="file in filesTicket" :key="file">
                <el-card class="file">
                  <div class="text item">
                    <span>{{ file }}<i style="padding: 0.2rem;" class="fas fa-download" @click="downloadFileTicket(currentTicketRef,file)"></i></span>
                  </div>
                </el-card>
              </div>
            </template>
          </div>
        </div>
      </div>
      <b-form @submit.prevent="sendMessage">
        <div>
          <b-form-group id="input-group-message">
            <b-form-file
              v-model="fileList"
              :state="Array(fileList)"
              placeholder="Choisir des fichiers ou les déposer ici..."
              drop-placeholder="Déposer ici..."
              multiple
              accept=".jpg, .png, .jpeg, .pdf, .txt, .docx, .xlsx"
            ></b-form-file>
          </b-form-group>

          <div style="display: flex;flex-direction: row;align-content: center;justify-content: center;align-items: stretch;width: 100%;">
            <wysiwyg v-model="formDiscussion.messageTicket" id="input-message" class="inputCreateTicket"/>
            <b-button id="sendMessage" type="submit" variant="primary">Envoyer Message</b-button>
          </div>
        </div>
      </b-form>
    </b-modal>


    <b-modal id="modalCreateTicket" ref="modalCreateTicket" @hide="closeCreateTicket" :title="modalCreateTicket.title" hide-footer>
      <b-form @submit.prevent="sendTicket">
        <b-form-group id="input-group-type">
          <label class="labelCreateTicket">Type de demande</label>
          <b-form-select id="input-type" class="inputCreateTicket" v-model="form.selectedType" :options="optionsTypeCreate"></b-form-select>
        </b-form-group>

        <b-form-group id="input-group-statut">
          <label class="labelCreateTicket">Sujet</label>
          <b-form-input type="text" id="input-sujet" class="inputCreateTicket" v-model="form.sujet"></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-statut">
          <label class="labelCreateTicket">Fichiers</label>
          <b-form-file
            v-model="fileList"
            :state="Array(fileList)"
            placeholder="Choisir des fichiers ou les déposer ici..."
            drop-placeholder="Déposer ici..."
            multiple
            accept=".jpg, .png, .jpeg, .pdf, .txt, .docx, .xlsx"
          ></b-form-file>
        </b-form-group>

        <b-form-group id="input-group-message">
          <label class="labelCreateTicket">Message</label>
          <wysiwyg v-model="form.messageTicket" id="input-message" class="inputCreateTicket"/>
        </b-form-group>

        <b-button id="sendTicket" type="submit" variant="primary">Envoyer ticket</b-button>
      </b-form>
    </b-modal>
  </div>   
</template>

<script>
import script from '../../../script/script_ticketSup.js';
var moment = require('moment')
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  data() {
    return {
      post: {},
      tickets:[],
      ticketMessages:[],
      messageInitial:"",
      titleCurrentTicket:"",
      currentTrack:"",
      currentTicketRef:"",
      currentPage: 1,
      perPage: 10,
      filter:null,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      totalRows: "",
      fieldsTickets:[{key:"ref",label:"Référence",class:"reference"},{key:"type",label:"Type de l'incident",class:"type"},{key:"sujet",value:"Sujet",class:"sujet"},{key:"date",value:"Date de l'incident",class:"date"},{key:"severite",value:"Sévérité",class:"severite"},{key:"statut",value:"Statut",class:"statut"},{key:"action",value:" ",class:"action"}],
      formMessage:{
        contenuMessage:""
      },
      editor: ClassicEditor,
      editorConfig:{
        
      },
      optionsType:[
        {value:'COM',text:"Demande commerciale"},
        {value:'ISSUE',text:"Demande technique"},
        {value:"DEMSAV", text:"Demande de SAV"},
        {value:'OTHER',text:"Autre"}
        ],
      optionsStatut:[
        {value:'0',text:"Non lu"},
        {value:'1',text:"Lu"},
        {value:'2',text:"Assigné"},
        {value:'3',text:"En cours"},
        {value:'5',text:"En attente de retour"},
        {value:'7',text:"En attente"},
        {value:'8',text:"Cloturé"},
      ],
      optionsSeverite:[
        {value:'LOW',text:"Bas"},
        {value:'NORMAL',text:"Normal"},
        {value:'HIGH',text:"Important"},
        {value:'BLOCKING',text:"Critique/Bloquant"}
      ],
      selectedType:0,
      selectedStatut:"tous",
      selectedSeverite:0,
      selectMode:'single',
      optionsTypeCreate:[
        {value:'COM',text:"Demande commerciale"},
        {value:'ISSUE',text:"Demande technique"},
        {value:"DEMSAV", text:"Demande de SAV"},
        {value:'OTHER',text:"Autre"}
        ],
      form:{
        selectedType:'COM',
        messageTicket:"",
        sujet:""
      },
      formDiscussion:{
        messageTicket:"",
      },
      modalCreateTicket: { title: 'Création de nouveau ticket', content: '' },
      modalInfoTicket: { title: '', content: '' },
      fileList: [],
      filesTicket: [],
      filterStatut:[],
      filterSeverity:[],
      filterType:[],

    }
  },
  mounted:function(){
    this.verifyRight();
    this.loadTicketsClient();
  },
  methods: {
    verifyRight: script.verifyRight,
    disconnect: script.disconnect,
    loadingInfo: script.loadingInfo,
    loadTicketsClient: script.loadTicketsClient,
    filterTicketsClient: script.filterTicketsClient,
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    expandTicketInfo: script.expandTicketInfo,
    masquerInfoTicket: script.masquerInfoTicket,
    downloadFileTicket: script.downloadFileTicket,
    sendMessage: script.sendMessage,
    openModal(target){
      this.$root.$emit('bv::show::modal', 'modalCreateTicket',target);
    },
    sendTicket: script.sendTicket,
    closeInfoTicket(){
			this.$refs.modalInfoTicket.hide()
		},
    closeCreateTicket(){
			this.$refs.modalCreateTicket.hide()
		},
    viewDate(date){
      return moment(date*1000).format('DD MMMM YYYY à HH:mm')
    },
    setPage (val) {
      this.currentPage = val
    },
    filterChange(filters){
      if(filters["el-table_1_column_6"]){
        if(filters["el-table_1_column_6"].length){
          this.filterStatut = filters["el-table_1_column_6"]
        }else{
          this.filterStatut = []
        }
      }else if(filters["el-table_1_column_5"]){
        if(filters["el-table_1_column_5"].length){
          this.filterSeverity = filters["el-table_1_column_5"]
        }else{
          this.filterSeverity = []
        }
      }else if(filters["el-table_1_column_2"]){
        if(filters["el-table_1_column_2"].length){
          this.filterType = filters["el-table_1_column_2"]
        }else{
          this.filterType = []
        }
      }
    }
  },
  components: {
    
  },
  computed:{
    info(){
      return this.$store.state.info
    },
    filteredData(){
      var ticketsTmp = this.tickets
      if(this.filterStatut.length){
        ticketsTmp = ticketsTmp.filter(row => this.filterStatut.includes(row.fk_statut))
      }
      if(this.filterSeverity.length){
        ticketsTmp = ticketsTmp.filter(row => this.filterSeverity.includes(row.severity_code))
      }
      if(this.filterType.length){
        ticketsTmp = ticketsTmp.filter(row => this.filterType.includes(row.type_code))
      }
      return ticketsTmp
    },
    pagedTableData() {
      return this.filteredData.slice(this.perPage * this.currentPage - this.perPage, this.perPage * this.currentPage)
    },
  }
  
}
</script>

<style>
#modalInfoTicket{
  height: 100%;
}

#modalInfoTicket .modal-dialog.modal-md{
  height: 90%;
  max-width: 70%;
}

#modalInfoTicket .modal-body{
  max-height: none;
}

#modalInfoTicket .modal-content{
  height: 100%;
}

#modalInfoTicket .messages{
  border: 1px solid gray;
  height: 350px;
  max-height: 350px;
  overflow-y: scroll;
  padding: 0.5rem;
  margin-bottom: 5px;
  width: 75%;
}

#modalInfoTicket .bannette{
  height: 350px;
  max-height: 350px;
  margin-bottom: 5px;
  width: 22%;
  font-size: 13px;
}

#modalInfoTicket .titreBannette{
  border: 1px solid gray;
  padding: 0.5rem;
}

#modalInfoTicket .fichiers{
  border: 1px solid gray;
  height: 300px;
  max-height: 300px;
  overflow-y: scroll;
  padding: 0.5rem;
}

#modalInfoTicket .fileTicket{
}

#modalInfoTicket .messagesEtBannette{
  display: flex;
  justify-content: space-between;
}

#modalInfoTicket .message .el-card__body{
  padding: 15px;
}

#modalInfoTicket .el-card.message{
  width: 85%;
}

#modalInfoTicket .myMessage{
  display: flex;
  justify-content: flex-end;
}

#modalInfoTicket .otherMessage{
  display: flex;
  justify-content: flex-start;
}

.sujet{
  width: 30%;
}

.reference{
  width: 8%;
}

.type{
  width: 13%;
}

.date{
  width: 10%;
}

.severite{
  width: 12%;
}

.statut{
  width: 7%;
}

.selectFilterFloat{
  width: 15%;
  float:left;
}

.selectFilter{
  width: 15%; 
}

.conversationIncident{
  height: 100%;
}

.envoiMessage{
  height:35%;
}

.messageDestinateur{
  color:white;
  width:60%;
  float:right;
  background-color: rgb(36, 170, 225);
  padding: 14px;
  border-radius: 20px;
  margin-bottom:1em;
}

.messageDestinataire{
  width:60%;
  background-color: rgb(197,197,197);
  padding: 14px;
  border-radius: 20px;
  margin-bottom:1em;
  float: left;
}

.labelCreateTicket{
  width: 20%;
  float: left;
}

.inputCreateTicket{
  width: 100%;
}

#input-message{
  float:right;
  width: 100%;
}

#sendTicket{
  float:right;
}

.createTicket,.createTicket:hover{
  background-color:#F8931C;
  border-color:#F8931C;
}
</style>
